import ResultsPieChart from "../../../charts/flashScreens/resultsStepScreen/ResultsPieChart";
import SystemResultsCardHeaderDivider from "../../../dividers/SystemResultsCardHeaderDivider";
import FlashResultsCardHeader from "../../../others/courses/flash/FlashResultsCardHeader";
import FlashResultsDesktopGraphCardLayout from "../../../layouts/courses/flash/FlashResultsDesktopGraphCardLayout";

export default function FlashResultsDesktopGraphCard({scores}) {
    // Used in FlashResultsScreen to display flash results in a pie chart

    // BUILD
    return (
        <div className={"w-full h-[280px] min-h-[280px] bg-backgroundLight5 shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px] flex flex-col"}>
            <FlashResultsCardHeader headerTitle={"Graphiques"} />
            <SystemResultsCardHeaderDivider />
            <FlashResultsDesktopGraphCardLayout>
                <ResultsPieChart scores={scores} />
            </FlashResultsDesktopGraphCardLayout>
        </div>
    );
}